// extracted by mini-css-extract-plugin
export default {"action-button":"WalletChargeContainer_action-button__fgpbm","btn-upload":"WalletChargeContainer_btn-upload__cz0Yl"};